The organizations the query's access token can act on behalf of.

For all token types this returns the name of the integration partner.

This query accepts browser tokens that include the `query:organizations` scope.
When provided with a browser token this will additionally return the scoped SEEK hirer.
